import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectCardPointDataForCardAndPointSystem = createSelector(
  orm,
  (_, cardId) => cardId,
  (_, __, pointSystemId) => pointSystemId,
  ({ CardPointData }, cardId, pointSystemId) => {
    if (!cardId || !pointSystemId) {
      return null;
    }

    const record = CardPointData.all()
      .filter({ cardId, pointSistemId: pointSystemId })
      .first();

    return record ? record.ref : null;
  },
);

export const makeSelectUnclosedCardPointDataForListAndCurrentMonth = () =>
  createSelector(
    orm,
    (_, listId) => listId,
    (_, __, pointSystemId) => pointSystemId,
    ({ List, Card, CardPointData }, listId, pointSystemId) => {
      if (!listId || !pointSystemId) {
        return [];
      }

      const listModel = List.withId(listId);
      if (!listModel) {
        return [];
      }

      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const cardModels = listModel.cards.toModelArray();
      const unclosedTasks = [];

      cardModels.forEach((cardModel) => {
        const cardPointDataModel = CardPointData.all()
          .filter({ cardId: cardModel.id, pointSistemId: pointSystemId })
          .first();

        if (cardPointDataModel && cardPointDataModel.closed !== true) {
          // Используем createdAt из CardPointData, если есть, иначе из Card
          const cardPointDataRef = cardPointDataModel.ref;
          const createdAt = cardPointDataRef.createdAt || cardModel.ref?.createdAt;
          
          if (createdAt) {
            const taskDate = new Date(createdAt);
            const taskYear = taskDate.getFullYear();
            const taskMonth = taskDate.getMonth();

            if (taskYear === currentYear && taskMonth === currentMonth) {
              unclosedTasks.push({
                cardId: cardModel.id,
                cardName: cardModel.name,
                cardPointData: cardPointDataRef,
              });
            }
          }
        }
      });

      return unclosedTasks;
    },
  );

export const selectUnclosedCardPointDataForListAndCurrentMonth = makeSelectUnclosedCardPointDataForListAndCurrentMonth();

export const makeSelectUnclosedCardPointDataForListAndMonth = () =>
  createSelector(
    orm,
    (_, listId) => listId,
    (_, __, pointSystemId) => pointSystemId,
    (_, __, ___, year) => year,
    (_, __, ___, ____, month) => month,
    ({ List, Card, CardPointData, ContentCardDefault, CardPointAdvancedData }, listId, pointSystemId, year, month) => {
      if (!listId || !pointSystemId || !year || !month) {
        return [];
      }

      const listModel = List.withId(listId);
      if (!listModel) {
        return [];
      }

      const cardModels = listModel.cards.toModelArray();
      const unclosedTasks = [];

      cardModels.forEach((cardModel) => {
        const cardPointDataModel = CardPointData.all()
          .filter({ cardId: cardModel.id, pointSistemId: pointSystemId })
          .first();

        if (cardPointDataModel && cardPointDataModel.closed !== true) {
          // Используем createdAt из CardPointData, если есть, иначе из Card
          const cardPointDataRef = cardPointDataModel.ref;
          const createdAt = cardPointDataRef.createdAt || cardModel.ref?.createdAt;
          
          if (createdAt) {
            const taskDate = new Date(createdAt);
            const taskYear = taskDate.getFullYear();
            const taskMonth = taskDate.getMonth() + 1; // getMonth() возвращает 0-11, нужно 1-12

            if (taskYear === year && taskMonth === month) {
              // Получаем ContentCardDefault
              const contentCardDefaultModel = cardPointDataModel.contentCardDefault;
              const contentCardDefault = contentCardDefaultModel ? contentCardDefaultModel.ref : null;

              // Получаем CardPointAdvancedData
              const cardPointAdvancedDataModels = CardPointAdvancedData.all()
                .filter({ cardId: cardModel.id, pointSistemId: pointSystemId })
                .toRefArray();

              unclosedTasks.push({
                cardId: cardModel.id,
                cardName: cardModel.name,
                cardPointData: cardPointDataRef,
                card: cardModel.ref,
                contentCardDefault,
                cardPointAdvancedData: cardPointAdvancedDataModels,
              });
            }
          }
        }
      });

      return unclosedTasks;
    },
  );

export const selectUnclosedCardPointDataForListAndMonth = makeSelectUnclosedCardPointDataForListAndMonth();

export default {
  selectCardPointDataForCardAndPointSystem,
  makeSelectUnclosedCardPointDataForListAndCurrentMonth,
  selectUnclosedCardPointDataForListAndCurrentMonth,
  makeSelectUnclosedCardPointDataForListAndMonth,
  selectUnclosedCardPointDataForListAndMonth,
};

